import axios from 'axios'

// 创建 axios 实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_NODE_URL || '/api', // 基础URL
  timeout: 15000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 添加 token 到请求头
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 可以在这里添加其他自定义逻辑
    // 比如添加时间戳、加密参数等
    return config
  },
  (error) => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    const res = response.data
    // 根据后端返回的状态码做不同处理
    // 这里假设后端返回格式为: { code: 200, data: {}, message: '' }
    if (res.code === 200 || response.status === 200 || response.success === true) {
      return res.data || res
    } else {
      // 业务错误处理
      console.error('业务错误:', res.message)
      return Promise.reject(new Error(res.message || '请求失败'))
    }
  },
  (error) => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    if (error.response) {
      // 请求已发出,但服务器响应的状态码不在 2xx 范围内
      switch (error.response.status) {
        case 401:
          // 未授权,清除token并跳转到登录页
          localStorage.removeItem('token')
          window.location.href = '/login'
          break
        case 403:
          console.error('没有权限访问')
          break
        case 404:
          console.error('请求的资源不存在')
          break
        case 500:
          console.error('服务器内部错误')
          break
        default:
          console.error(`请求失败: ${error.response.status}`)
      }
    } else if (error.request) {
      // 请求已发出,但没有收到响应
      console.error('网络错误,请检查网络连接')
    } else {
      // 发送请求时出了点问题
      console.error('请求配置错误:', error.message)
    }
    return Promise.reject(error)
  }
)

export default request
